import React, {useState}from "react"
import { Typography, Button, Alert, TextField, Autocomplete,  } from '@mui/material'
import DatePicker from '@mui/lab/DatePicker';
import { BusinessOutlined, Search } from '@mui/icons-material'
import styles from './ManageUsersInfo.module.scss'
import Modal from '../../components/Modal'
import ManageCompanyPermissions from './components/ManageCompanyPermissions'

import styles1 from '../Login.module.scss'
import axios from "axios";

export default function ManageCompany() {
    const [isOpen, setIsOpen] = useState(false)
    const [CompanyName, setCompanyName] = useState('')
    const [validity, setvalidity] = useState()
    const [althub_client_id, setalthub_client_id] = useState()
    const [isError, setIsError] = useState(false)
    const [info, setInfo] = useState('')



    const handleOpenModal = () => setIsOpen(!isOpen)

    const CreateCompany = (event) => {
        event.preventDefault()
        setIsError(false)
        // fetch('/api/CreateCompany', {
        //     method: 'post',
        //     headers: {'Content-Type': 'application/json'},
        //     body: JSON.stringify({company_name: CompanyName, validity: validity, althub_client_id: althub_client_id})
        // })
        axios({
            method: 'post',
            url: '/api/CreateCompany',
            data: {company_name: CompanyName, validity: validity, althub_client_id:althub_client_id}
        }).then(result => {
            if (result.status === 200) {
                setInfo(result.data.result)
                handleOpenModal()
            } else {
                setIsError(true)
                setInfo(result.data.result)
            }
        }).catch(e => {
            setIsError(true)
        })
    }


    return (
        // <section>
        //     <Typography variant="h2">Manage Datasets</Typography>
        //     <ManageCompanyPermissions/>
        // </section>
        <div className={styles["container-manage-user-info"]}>
            <div className={`${styles["display-flex-row"]} ${styles["display-header-container"]}`}>
                <div className={styles["display-flex-row"]}>
                    <BusinessOutlined fontSize='large'/>
                    <Typography variant="h1">Manage Company</Typography>
                </div>
                <Button onClick={handleOpenModal} variant="contained" color="primary">Add new company</Button>
            </div>



            <ManageCompanyPermissions />


            <Modal open={isOpen} handleClose={handleOpenModal} title="Add a new company">
                {/* <Signup /> */}
                <div className={styles1['loginCard']}>
                    <form className={styles1['form']} onSubmit={CreateCompany}>
                        <TextField
                            id="outlined-basic" 
                            label="Company Name" 
                            variant="outlined"
                            value={CompanyName}
                            placeholder="Company Name"
                            onChange={e => { setCompanyName(e.target.value) }}
                            type="text"
                        />
                        <TextField
                            id="outlined-basic" 
                            label="Validity -(DD/MM/YYYY)" 
                            variant="outlined"
                            value={validity}
                            placeholder="Validity -(DD/MM/YYYY)"
                            onChange={e => { setvalidity(e.target.value) }}
                            type="text"
                        />
                        <TextField
                            id="outlined-basic" 
                            label="Althub Client ID"
                            variant="outlined"
                            value={althub_client_id}
                            placeholder="Althub Client ID"
                            onChange={e => { setalthub_client_id(e.target.value) }}
                            type="number"
                        />
                        
                        <Button type="submit" color="primary" variant="contained">Create Company</Button>
                    </form>
                </div>
            </Modal>
        </div>
        
    )
} 



